import api from './api'

const attendanceService = {
  // 基礎打卡
  checkIn: (data) => {
    return api.post('/attendance/check-in', data)
  },

  checkOut: (data) => {
    return api.post('/attendance/check-out', data)
  },

  getRecords: (params) => {
    return api.get('/attendance/records', { params })
  },

  getRecord: (id) => {
    return api.get(`/attendance/records/${id}`)
  },

  getLocations: () => {
    return api.get('/attendance/locations')
  },

  // 補打卡申請
  createCorrection: (data) => {
    return api.post('/attendance/corrections/create', data)
  },

  getCorrections: (params) => {
    return api.get('/attendance/corrections', { params })
  },

  getCorrection: (id) => {
    return api.get(`/attendance/corrections/${id}`)
  },

  approveCorrection: (id) => {
    return api.post(`/attendance/corrections/${id}/approve`)
  },

  rejectCorrection: (id, comment) => {
    return api.post(`/attendance/corrections/${id}/reject`, { comment })
  },

  // 出勤異常
  getAnomalies: (params) => {
    return api.get('/attendance/anomalies', { params })
  },

  detectAnomalies: (date) => {
    return api.post('/attendance/detect-anomalies', { date })
  },

  handleAnomaly: (id, action, note) => {
    return api.post(`/attendance/anomalies/${id}/handle`, { action, note })
  },
}

export default attendanceService
